import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/index'
import elementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css';
// import Avue from '@smallwei/avue';
// import '@smallwei/avue/lib/index.css';
import api from './api/index'
//import { setCookie, getCookie, removeCookie, objectDefaults } from './util'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.use(elementUi)
// Vue.use(Avue);
//引入echarts图表库
import echarts from 'echarts'
Vue.prototype.echarts = echarts
//Vue.prototype.setCookie = setCookie
Vue.prototype.api = api
Vue.prototype.baseUrl = api.baseUrl
//引入axios文件
import axios from 'axios'
import 'babel-polyfill'
import Qs from 'qs'
Vue.prototype.axios = axios
Vue.prototype.qs = Qs
Vue.prototype.apiUrl = process.env.apiUrl
Vue.config.productionTip = false

// ====== 旧互通登录代码（已废弃，由 IamLoginModal 预加载 iframe + tokenBridge 广播替代）======
// var healthDbLoginHandled = false;
// var SESSION_EXPIRED_FLAG = "dbSessionExpiredHandled";
// var allowedHealthMessageOrigins = [...];
// function isHealthHandshakeMode() {...}
// function resolveDbAppTarget(targetUrl) {...}
// function navigateDbAppTarget(targetUrl) {...}
// function runDbPostLoginHooks() {...}
// function handleHealthSiteAutoLogin(payload) {...}
// window.addEventListener("message", ...)
// setupHealthToDbHandshake() {...}
// ====== 结束 ======
window.ty = Vue.prototype.ty = {
  computeStrWidth(str){
    let span = document.querySelector('#ty-computeWidth-th');
    span.innerHTML = str;
    return span.offsetWidth;
  }
  ,sum(key,arr){
    return arr.map(e=>e[key]).reduce((a,b)=>a+b,0);
  }
  ,addHeadProperty: {
    width(head,data){
      //计算各列最大宽度，并赋值个width属性，最大不超过Cons.maxCellWidth
      head = head.map(e=>{
        e.width = Math.max(...[ty.computeStrWidth(e.label)+Cons.sortW,...data.map(ee=>ty.computeStrWidth(ee[e.value]))]);
        //加上el-table .cell>div有左右padding
        e.width += 20;
        if(e.width>Cons.maxCellWidth){
          e.width = Cons.maxCellWidth;
        }
        return e;
      })
      //获取表头总宽度
      let sumWidth = 0;
      head.map(e=>sumWidth+=Math.round(e.width));
      try {
        //如果表格所有列宽度加起来，还没占满屏幕。那么就不按这个computeWidth来。
        console.log(sumWidth,document.querySelector('.search-details-wrapper'),document.querySelector('.search-details-wrapper').offsetWidth);
        if(sumWidth<document.querySelector('.search-details-wrapper').offsetWidth-130){
          head = head.map(e=>{
            if(e.label.match(/上市许可持有人|日常监管机构/)){
              return e;
            }
            delete e.width;
            return e;
          })
        }
      }catch (e) {

      }
      return head;
    }
  },
  getMenuItem(name,menuData=vm.$store.state.menuData){
    let getMenuItem = (name,menuData)=>{
      let res = null;
      for(let i=0,I=menuData[i];I;I=menuData[++i]){
        if(I.entity.name == name){
          console.log('ok',JSON.parse(JSON.stringify(I)));
          res = I;
          break;
        }
      }
      if(res==null){
        for(let i=0,I=menuData[i];I;I=menuData[++i]){
          if(I.children && I.children.length){
            // console.log('入',name,I.children.map(e=>e.entity.name));
            res = getMenuItem(name,I.children);
            if(res){
              break;
            }
          }
        }
      }
      return res;
    }
    return getMenuItem(name,menuData);
  }
}
window.Cons = Vue.prototype.Cons = {
  sortW: 50
  ,indexW: 50
  ,pageSizes: [10, 20, 30, 40, 50, 100]
  ,pageSize: 20
  ,maxCellWidth: 300
  ,plate: 8
}
router.beforeEach(function (to, from, next) {
  if (!store.state.userInfo) {
    let token = localStorage.getItem("token");
    if (token == null || token == '') {
      var query = '';
      if (window.location.hash != '' && window.location.hash != null) {
        query = window.location.hash.split('?')[1];
      }
      if (query && query != '') {
        var param="";
        if(query.indexOf("&")>0){
          var vars = query.split("&");
          param = {
            code: vars[0].split('=')[1],
            type: vars[1].split('=')[1]
          }}
        api.getUserInfoByCode(Object.assign(param)).then(res => {
            store.commit("SetuserInfo", res)
            localStorage.setItem("token", res.token);
            localStorage.removeItem("dmiToken");
            next()
          })
          .catch(error => {
            next()
            store.commit("ChangeLoginStatus", false)
          })
      } else {
        if (to.meta.requireAuth) {
          store.commit("ChangeLoginStatus", true);
          next();
        } else {
          next();
        }

      }
    } else {
      if (to.meta.requireAuth) {
        api.getUserInfo()
          .then(res => {
            store.commit("SetuserInfo", res)
            next()
          })
          .catch(error => {
            elementUi.Message(error);
            localStorage.removeItem("token");
            localStorage.removeItem("dmiToken");
            store.commit("ChangeLoginStatus", true)
            next()
          })
      } else {
        api.getUserInfo()
          .then(res => {
            store.commit("SetuserInfo", res)
            next()
          })
          .catch(error => {
            elementUi.Message(error);
            store.commit("ChangeLoginStatus", false)
            localStorage.removeItem("token");
            localStorage.removeItem("dmiToken");
            next()
          })
      }
    }
  } else {
    next()
  }
})

// ====== 跨标签同步登录状态 ======
// 当另一个标签页登录或退出时，storage 事件会触发，刷新当前页同步状态
window.addEventListener("storage", function (event) {
  console.log("[777 main.js] storage event fired, key:", event.key, "oldValue:", event.oldValue ? "length " + event.oldValue.length : "null", "newValue:", event.newValue ? "length " + event.newValue.length : "null");
  if (event.key === "token") {
    console.log("[777 main.js] storage event key is token, reloading page");
    window.location.reload();
  }
});

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js